const pimg1 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80';
const pimg2 = 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80';
const pimg3 = 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800&q=80';
const pimg4 = 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80';
const pimg5 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80';

const psimg1 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1200&q=80';
const psimg2 = 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1200&q=80';
const psimg3 = 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=1200&q=80';
const psimg4 = 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80';
const psimg5 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1200&q=80';


const Projects = [
    {
        id: '01',
        subtitle: 'Projet Récent',
        title: 'Façades Aluminium',
        docomunt: 'Réalisation de façades en aluminium pour unité industrielle à Tunis. Profils extrudés sur mesure avec finitions anodisées haute qualité.',
        slug: 'Special-Transport-Solutions',
        pimg: pimg1,
        psimg: psimg1,
        location: 'Chotrana 1 sidi salah , Tunisie',
        date: '15 Déc 2024',
    },

    {
        id: '02',
        subtitle: 'Projet Récent',
        title: 'Structures Industrielles',
        docomunt: 'Fabrication de structures en aluminium pour une plateforme logistique en Tunisie. Assemblage et usinage de précision selon plans techniques.',
        slug: 'Special-Transport-Solutions2',
        pimg: pimg2,
        psimg: psimg2,
        location: 'Parc Industriel Sfax, Sfax',
        date: '15 Déc 2024',
    },
    {
        id: '03',
        subtitle: 'Projet Récent',
        title: 'Équipements Sur Mesure',
        docomunt: 'Conception et fabrication d\'équipements en aluminium pour ligne de production dans une usine agroalimentaire tunisienne. Optimisation des performances et de la durabilité.',
        slug: 'Special-Transport-Solutions3',
        pimg: pimg3,
        psimg: psimg3,
        location: 'Zone Industrielle Mghira, Ben Arous',
        date: '15 Déc 2024',
    },
    {
        id: '04',
        subtitle: 'Projet Récent',
        title: 'Systèmes de Fenêtrage',
        docomunt: 'Production de systèmes de fenêtrage en aluminium pour bâtiments commerciaux à Tunis et dans les grandes villes tunisiennes. Isolation thermique et acoustique optimale.',
        slug: 'Special-Transport-Solutions4',
        pimg: pimg4,
        psimg: psimg4,
        location: 'Centre Commercial, Tunis',
        date: '15 Déc 2024',
    },
    
    {
        id: '05',
        subtitle: 'Projet Récent',
        title: 'Pièces Mécaniques',
        docomunt: 'Usinage de pièces mécaniques en aluminium pour le secteur automobile en Tunisie. Tolérances serrées et finitions de qualité supérieure.',
        slug: 'Special-Transport-Solutions5',
        pimg: pimg5,
        psimg: psimg5,
        location: 'Usine Automobile, Sousse',
        date: '15 Déc 2024',
    },

]
export default Projects;






